import request from '@/utils/http.js'

/**
 * 家长/老师查询学生详细信息
 */
export function getUserList (guardianId, guardianType) {
  return request.post({
    url: `/api/guardian-rel/guardian/${guardianId}/type/${guardianType}`
  })
}

/**
 * 获取学生列表
 * @param params
 * @returns {Promise}
 */
export function students (params) {
  return request.post({
    url: '/user/search/students',
    params
  })
}

/**
 * 家长/老师绑定学生
 */
export function bind (guardianId, guardianType, studentId, options = {}) {
  const query = [
    `guardianId=${guardianId}`,
    `guardianType=${guardianType}`,
    `studentId=${studentId}`
  ]
  if (options.relation) {
    query.push(`relation=${encodeURIComponent(options.relation)}`)
  }
  if (options.operator) {
    query.push(`operator=${encodeURIComponent(options.operator)}`)
  }
  if (options.activate) {
    query.push('activate=true')
  }
  return request.post({
    url: `/api/guardian-rel/bind?${query.join('&')}`
  })
}
/**
 * 家长/老师绑定学生
 */
export function deleteBing (id) {
  return request.get({
    url: `api/guardian-rel/delete/${id}`
  })
}

export function knowledgeStats (params) {
  return request.post({
    url: '/api/student/course/knowledge-stats',
    params
  })
}
